// TTL-based sessionStorage cache for short-lived client state (e.g. restoring a result
// list on return navigation). Values are timestamped and expire once older than their ttl.
// All access is a no-op on the server and never throws if storage is unavailable or full.

const isAvailable = () => typeof window !== 'undefined' && !!window.sessionStorage;

export const readCache = (key, ttl) => {
  if (!isAvailable()) {
    return null;
  }

  try {
    const raw = window.sessionStorage.getItem(key);
    if (!raw) {
      return null;
    }

    const entry = JSON.parse(raw);
    if (!entry || typeof entry.timestamp !== 'number') {
      return null;
    }

    if (ttl && Date.now() - entry.timestamp > ttl) {
      window.sessionStorage.removeItem(key);
      return null;
    }

    return entry.value;
  } catch (e) {
    return null;
  }
};

export const writeCache = (key, value) => {
  if (!isAvailable()) {
    return;
  }

  try {
    window.sessionStorage.setItem(key, JSON.stringify({ value, timestamp: Date.now() }));
  } catch (e) {
    // Quota exceeded or serialization error - caching is best-effort.
  }
};

export const clearCache = (key) => {
  if (!isAvailable()) {
    return;
  }

  try {
    window.sessionStorage.removeItem(key);
  } catch (e) {
    // ignore
  }
};